export interface IconProps {
  height: number;
}

export const Instagram: React.FC<IconProps> = ({ height }) => {
  return (
    <svg
      height={`${height + 1}px`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="https://www.w3.org/2000/svg"
    >
      <path
        d="M12.0002 0.333008C15.17 0.333008 15.5655 0.344674 16.8092 0.403008C18.0517 0.461341 18.8975 0.656175 19.6418 0.945508C20.4118 1.24184 21.0605 1.64317 21.7092 2.29067C22.3024 2.87389 22.7614 3.57936 23.0543 4.35801C23.3425 5.10117 23.5385 5.94817 23.5968 7.19067C23.6517 8.43434 23.6668 8.82984 23.6668 11.9997C23.6668 15.1695 23.6552 15.565 23.5968 16.8087C23.5385 18.0512 23.3425 18.897 23.0543 19.6413C22.7623 20.4204 22.3031 21.1261 21.7092 21.7087C21.1258 22.3017 20.4204 22.7607 19.6418 23.0538C18.8987 23.342 18.0517 23.538 16.8092 23.5963C15.5655 23.6512 15.17 23.6663 12.0002 23.6663C8.83033 23.6663 8.43483 23.6547 7.19116 23.5963C5.94866 23.538 5.10283 23.342 4.3585 23.0538C3.57954 22.7616 2.87394 22.3024 2.29116 21.7087C1.6978 21.1256 1.23875 20.4201 0.945996 19.6413C0.656663 18.8982 0.461829 18.0512 0.403496 16.8087C0.348663 15.565 0.333496 15.1695 0.333496 11.9997C0.333496 8.82984 0.345163 8.43434 0.403496 7.19067C0.461829 5.94701 0.656663 5.10234 0.945996 4.35801C1.23794 3.57888 1.6971 2.87322 2.29116 2.29067C2.87411 1.69711 3.57966 1.23803 4.3585 0.945508C5.10283 0.656175 5.9475 0.461341 7.19116 0.403008C8.43483 0.348174 8.83033 0.333008 12.0002 0.333008ZM12.0002 6.16634C10.4531 6.16634 8.96934 6.78092 7.87537 7.87489C6.78141 8.96885 6.16683 10.4526 6.16683 11.9997C6.16683 13.5468 6.78141 15.0305 7.87537 16.1245C8.96934 17.2184 10.4531 17.833 12.0002 17.833C13.5473 17.833 15.031 17.2184 16.125 16.1245C17.2189 15.0305 17.8335 13.5468 17.8335 11.9997C17.8335 10.4526 17.2189 8.96885 16.125 7.87489C15.031 6.78092 13.5473 6.16634 12.0002 6.16634ZM19.5835 5.87467C19.5835 5.4879 19.4299 5.11697 19.1564 4.84348C18.8829 4.56999 18.5119 4.41634 18.1252 4.41634C17.7384 4.41634 17.3675 4.56999 17.094 4.84348C16.8205 5.11697 16.6668 5.4879 16.6668 5.87467C16.6668 6.26145 16.8205 6.63238 17.094 6.90587C17.3675 7.17936 17.7384 7.33301 18.1252 7.33301C18.5119 7.33301 18.8829 7.17936 19.1564 6.90587C19.4299 6.63238 19.5835 6.26145 19.5835 5.87467ZM12.0002 8.49968C12.9284 8.49968 13.8187 8.86842 14.475 9.5248C15.1314 10.1812 15.5002 11.0714 15.5002 11.9997C15.5002 12.9279 15.1314 13.8182 14.475 14.4745C13.8187 15.1309 12.9284 15.4997 12.0002 15.4997C11.0719 15.4997 10.1817 15.1309 9.52529 14.4745C8.86891 13.8182 8.50016 12.9279 8.50016 11.9997C8.50016 11.0714 8.86891 10.1812 9.52529 9.5248C10.1817 8.86842 11.0719 8.49968 12.0002 8.49968Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Facebook: React.FC<IconProps> = ({ height }) => {
  return (
    <svg
      height={`${height}px`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="https://www.w3.org/2000/svg"
    >
      <path
        d="M16.9213 13.398L17.5825 9.08737H13.4466V6.29002C13.4466 5.11069 14.0243 3.96117 15.8768 3.96117H17.7573V0.291281C17.7573 0.291281 16.0507 0 14.4192 0C11.0128 0 8.78642 2.06447 8.78642 5.80195V9.08737H5V13.398H8.78642V23.8188C9.54566 23.9379 10.3238 24 11.1165 24C11.9092 24 12.6874 23.9379 13.4466 23.8188V13.398H16.9213Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Twitter: React.FC<IconProps> = ({ height }) => {
  return (
    <svg
      height={`${height}px`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="https://www.w3.org/2000/svg"
    >
      <path
        d="M14.0955 10.3165L22.2864 1H20.3456L13.2303 9.08768L7.55141 1H1L9.58949 13.2311L1 23H2.94072L10.4501 14.4571L16.4486 23H23L14.0955 10.3165ZM11.4365 13.3385L10.5649 12.1198L3.64059 2.43161H6.62193L12.2117 10.2532L13.0797 11.4719L20.3447 21.6381H17.3634L11.4365 13.3385Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const TikTok: React.FC<IconProps> = ({ height }) => {
  return (
    <svg
      height={`${height}px`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="https://www.w3.org/2000/svg"
    >
      <path
        d="M22.9998 9.83953C20.9361 9.84447 18.923 9.20088 17.2449 7.99969V16.3772C17.2444 17.9288 16.7701 19.4432 15.8856 20.718C15.0011 21.9928 13.7484 22.9672 12.2952 23.5109C10.842 24.0545 9.25738 24.1416 7.75334 23.7604C6.24929 23.3791 4.89748 22.5478 3.87865 21.3776C2.85982 20.2074 2.22254 18.754 2.05202 17.2118C1.8815 15.6696 2.18587 14.112 2.92444 12.7475C3.663 11.3829 4.80055 10.2764 6.18498 9.5758C7.56942 8.87521 9.13474 8.61398 10.6716 8.82703V13.0406C9.96836 12.8194 9.21315 12.8261 8.51387 13.0597C7.81459 13.2933 7.207 13.7418 6.77787 14.3413C6.34875 14.9408 6.12002 15.6606 6.12436 16.3979C6.12871 17.1351 6.36589 17.8521 6.80205 18.4466C7.23821 19.041 7.85104 19.4824 8.55303 19.7077C9.25501 19.933 10.0102 19.9308 10.7109 19.7013C11.4115 19.4718 12.0217 19.0268 12.4544 18.4298C12.887 17.8329 13.1199 17.1145 13.1199 16.3772V0H17.2449C17.2421 0.348347 17.2712 0.696219 17.3321 1.03922C17.4755 1.80491 17.7735 2.53332 18.208 3.17988C18.6425 3.82643 19.2043 4.37756 19.8591 4.79953C20.7907 5.41551 21.8829 5.74383 22.9998 5.74359V9.83953Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const LinkedIn: React.FC<IconProps> = ({ height }) => {
  return (
    <svg
      height={`${height}px`}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M44.4567 0H3.54333C2.60358 0 1.70232 0.373315 1.03782 1.03782C0.373315 1.70232 0 2.60358 0 3.54333V44.4567C0 45.3964 0.373315 46.2977 1.03782 46.9622C1.70232 47.6267 2.60358 48 3.54333 48H44.4567C45.3964 48 46.2977 47.6267 46.9622 46.9622C47.6267 46.2977 48 45.3964 48 44.4567V3.54333C48 2.60358 47.6267 1.70232 46.9622 1.03782C46.2977 0.373315 45.3964 0 44.4567 0ZM14.3067 40.89H7.09V17.9667H14.3067V40.89ZM10.6933 14.79C9.87473 14.7854 9.07583 14.5384 8.39747 14.0802C7.71911 13.622 7.19168 12.9731 6.88175 12.2154C6.57183 11.4577 6.4933 10.6252 6.65606 9.82291C6.81883 9.02063 7.2156 8.28455 7.79631 7.70756C8.37702 7.13057 9.11563 6.73853 9.91893 6.58092C10.7222 6.42331 11.5542 6.50719 12.3099 6.82197C13.0656 7.13675 13.7111 7.66833 14.1649 8.34962C14.6188 9.03092 14.8606 9.83138 14.86 10.65C14.8677 11.1981 14.765 11.7421 14.558 12.2496C14.351 12.7571 14.044 13.2178 13.6551 13.6041C13.2663 13.9905 12.8037 14.2946 12.2948 14.4983C11.786 14.702 11.2413 14.8012 10.6933 14.79ZM40.9067 40.91H33.6933V28.3867C33.6933 24.6933 32.1233 23.5533 30.0967 23.5533C27.9567 23.5533 25.8567 25.1667 25.8567 28.48V40.91H18.64V17.9833H25.58V21.16H25.6733C26.37 19.75 28.81 17.34 32.5333 17.34C36.56 17.34 40.91 19.73 40.91 26.73L40.9067 40.91Z"
        fill="currentcolor"
      />
    </svg>
  );
};
